export default __webpack_public_path__ + "static/media/excel.7b6ffb3e.svg";